import { render, staticRenderFns } from "./DataContributorHeader.vue?vue&type=template&id=1edd20f2&scoped=true"
import script from "./DataContributorHeader.vue?vue&type=script&lang=js"
export * from "./DataContributorHeader.vue?vue&type=script&lang=js"
import style0 from "./DataContributorHeader.vue?vue&type=style&index=0&id=1edd20f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd20f2",
  null
  
)

export default component.exports